export default __webpack_public_path__ + "static/media/priority-high-glyph-16-px.a415a1a3.svg";